import ButtonComponent from './Button.component';

export * from './Button.component';
export default ButtonComponent;
